import { useQuery } from "react-query";
import { getJudges } from "../../services/scientific/judges";
import { PagedRequestType } from "../../types/PagedResults";
import { JUDGES, Key_judges } from "../../utils/constants";


export const useGetJudgesQuery = (data: PagedRequestType) =>
  useQuery(
    [Key_judges, JSON.stringify(data)],
    () => getJudges(data)
  );
